import { Children, cloneElement, isValidElement, type ReactElement, type ReactNode } from "react";

import Icons, { type SVGIconProps } from "assets";

const ICON_COMPONENTS: unknown[] = Object.values(Icons);

export const isIconElement = (node: ReactNode): node is ReactElement<SVGIconProps> =>
  isValidElement(node) && ICON_COMPONENTS.includes(node.type);

export const childIsSingleIcon = (children: ReactNode): boolean => {
  const childArray = Children.toArray(children);
  if (childArray.length !== 1) return false;

  return isIconElement(childArray[0]);
};

/**
 * MUI sizes button icons through `font-size`, which our SVGR icons ignore — they render hardcoded
 * `width`/`height` attributes, so those are what must be set.
 */
export const sizeIconElement = (icon: ReactNode, px: number): ReactNode =>
  isIconElement(icon) ? cloneElement(icon, { width: px, height: px, ...icon.props }) : icon;
